/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import _ from 'lodash';
import { dateUtils } from 'utils';
import ChatMessage from './ChatMessage';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function ChatMessages({ messages = [], isVideoChat, accountId, participants, onDownload, downloadingList }) {
  const classes = useStyles();
  const messagesEndRef = useRef(null);
  const monthName = (item) => dateUtils.fullFormatDateTimeString(item.createdAt);
  const groupedMessages = _.groupBy(messages, monthName);

  const scrollToBottom = () => messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <div className={classes.chatMessages}>
      {Object.keys(groupedMessages).map((key) => {
        const msg = groupedMessages[key];
        return (
          <div key={key}>
            <Typography className={classes.currentSectionDate} variant="caption" component="p">
              {key}
            </Typography>
            {msg.map((message, index, array) => {
              const isUser = accountId === message.senderId;
              const isFirstUserMessage = index === 0 || (array[index - 1] && message.senderId !== array[index - 1].senderId);
              const isLastUserMessage = array.length - 1 === index || (array[index + 1] && message.senderId !== array[index + 1].senderId);
              const isMoreThanHourDifference = dateUtils.isMoreThanHourDifference(array[index + 1]?.createdAt, array[index]?.createdAt);

              return (
                <ChatMessage
                  {...message}
                  senderId={message.senderId}
                  isVideoChat={isVideoChat}
                  isUser={isUser}
                  showAvatar={isFirstUserMessage}
                  showSender={isFirstUserMessage}
                  showTimestamp={isMoreThanHourDifference || isLastUserMessage}
                  key={message.id}
                  participants={participants}
                  onDownload={onDownload}
                  downloadingList={downloadingList}
                />
              );
            })}
          </div>
        );
      })}
      <div ref={messagesEndRef} />
    </div>
  );
}

ChatMessages.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.object).isRequired,
  accountId: PropTypes.string,
  participants: PropTypes.arrayOf(PropTypes.object),
  isVideoChat: PropTypes.bool,
  onDownload: PropTypes.func.isRequired,
  downloadingList: PropTypes.arrayOf(PropTypes.string).isRequired,
};

ChatMessages.defaultProps = {
  isVideoChat: false,
  participants: [],
  accountId: '',
};

export default ChatMessages;
